import { render, staticRenderFns } from "./WorldHelpLabel.vue?vue&type=template&id=65f38b34&scoped=true&"
import script from "./WorldHelpLabel.vue?vue&type=script&lang=js&"
export * from "./WorldHelpLabel.vue?vue&type=script&lang=js&"
import style0 from "./WorldHelpLabel.vue?vue&type=style&index=0&id=65f38b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f38b34",
  null
  
)

export default component.exports